"use strict";

import { onReady } from './ready.js';
import { addAttributesToOuterLinks, backToTop, anchorScroll } from './common.js';
import { initLenis } from './lenis.js';
import { initScrollReveal } from './scroll-reveal.js';
import { colorsFilterBar } from './colors.js';
import { initMenu } from '../partials/menu.js';
import { initHomeHeroIndex } from '../partials/home-hero.js';

function initCore() {
    initLenis();
    initScrollReveal();
    addAttributesToOuterLinks();
    backToTop();
    anchorScroll();
    initMenu();
    initHomeHeroIndex();
    colorsFilterBar();
}

// Ready + ogni page:view
onReady(initCore);
